export const IconLightBulb = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M12 22q-.65 0-1.175-.312A2.3 2.3 0 0 1 10 20.85q-.825 0-1.412-.588A1.93 1.93 0 0 1 8 18.85V15.3a7.24 7.24 0 0 1-2.362-2.575A7.05 7.05 0 0 1 4.75 9.25q0-3.026 2.113-5.137Q8.974 2 12 2q3.026 0 5.137 2.113Q19.25 6.225 19.25 9.25q0 1.925-.887 3.5A7.3 7.3 0 0 1 16 15.3v3.55q0 .825-.588 1.412A1.93 1.93 0 0 1 14 20.85 2.27 2.27 0 0 1 12 22m-2-3.15h4v-.9h-4zm0-1.9h4V16h-4zM9.8 14h1.45v-2.7l-2.2-2.2 1.05-1.05 1.9 1.9 1.9-1.9 1.05 1.05-2.2 2.2V14h1.45a5.5 5.5 0 0 0 2.2-1.912q.85-1.263.85-2.838 0-2.2-1.525-3.725T12 4 8.275 5.525 6.75 9.25q0 1.575.85 2.838Q8.45 13.35 9.8 14" />
    </svg>
  );
};
